// My profile (docs/plans/sign-in.md, Screens): name, email, role, who manages them, and the
// two-step sign-in with Forget this device. Markup from the Dialog card and the board.
import type { Me } from '../auth/api';
import { copy } from '../auth/copy';
import { Dialog } from './Dialog';
import { managedBy, shortDate } from './profile-lines';

type MyProfileDialogProps = {
  me: Me;
  onClose: () => void;
  onForgetDevice: () => void;
  forgetting: boolean;
};

export function MyProfileDialog({ me, onClose, onForgetDevice, forgetting }: MyProfileDialogProps) {
  const { user, deviceRememberedUntil } = me;
  const managed = managedBy(user.role);
  return (
    <Dialog
      id="my-profile-title"
      title={copy.myProfile}
      subline={`${user.name} | ${user.role}`}
      onClose={onClose}
      footer={
        <button type="button" className="btn ml-auto" onClick={onClose}>
          {copy.close}
        </button>
      }
    >
      <dl className="pdl">
        <div>
          <dt>Name</dt>
          <dd>{user.name}</dd>
        </div>
        <div>
          <dt>Email</dt>
          <dd>{user.email}</dd>
        </div>
        <div>
          <dt>Role</dt>
          <dd>{user.role}</dd>
        </div>
      </dl>
      {managed && <p className="fnote m0">{managed}</p>}
      <div className="pm-row">
        <span className="t13 ink">{copy.notifications}</span>
        <span className="tag t-grey">{copy.phase2}</span>
      </div>
      <div className="pm-row">
        <span className="col g2">
          <span className="t13 ink">{copy.twoStep}</span>
          <span className="t12 muted">{copy.codeByEmail}</span>
          {deviceRememberedUntil ? (
            <>
              <span className="t12 muted">
                {copy.rememberedUntil(shortDate(deviceRememberedUntil))}
              </span>
              <button
                type="button"
                className="linkbtn pm-link"
                disabled={forgetting}
                onClick={onForgetDevice}
              >
                {copy.forgetDevice}
              </button>
            </>
          ) : (
            <span className="t12 muted">{copy.notRemembered}</span>
          )}
        </span>
        <span className="tag t-green">{copy.on}</span>
      </div>
    </Dialog>
  );
}
